<template>
  <table-render ref="tableRender" :config="config" />
</template>

<script>
import tableRender from '@/components/tableRender';
import { subAccountLog as config } from './config';
export default {
  props: {
    subAccountNumberId: {
      type: [String, Number],
      require: true
    }
  },
  name: 'SubAccountLog',
  data() {
    return {
      config
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    console.log(this.config[0].childMenu[0]);

    this.config[0].childMenu[0].defaultQueryHotfix.subAccountNumberId = this.subAccountNumberId
  },
  mounted() {
    console.log(this.$refs.tableRender);
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
